import React, { useEffect, useState } from 'react';
import { ShieldCheck } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import {
  isNative,
  isBiometryAvailable,
  isBiometricPromptSeen,
  markBiometricPromptSeen,
  setBiometricLockEnabled,
  runBiometricAuth,
} from '../utils/biometric';

// Tras el primer login en nativo, si el dispositivo tiene biometría y aún no se
// preguntó, ofrece activar el bloqueo con Face ID / Touch ID / huella. Se muestra
// una sola vez (bandera `biometric_prompt_seen`).
export const BiometricSetupPrompt: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!isNative() || !isAuthenticated || isBiometricPromptSeen()) return;
      const available = await isBiometryAvailable();
      if (!cancelled && available) setVisible(true);
    })();
    return () => {
      cancelled = true;
    };
  }, [isAuthenticated]);

  const enable = async () => {
    markBiometricPromptSeen();
    // Confirmamos con una autenticación real antes de activar, para no dejar al
    // usuario bloqueado si la biometría no funciona en su dispositivo.
    const ok = await runBiometricAuth('Confirma para activar el bloqueo');
    setBiometricLockEnabled(ok);
    setVisible(false);
  };

  const skip = () => {
    markBiometricPromptSeen();
    setBiometricLockEnabled(false);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/50 p-6">
      <div className="w-full max-w-sm rounded-3xl bg-[var(--color-surface)] p-6 text-center">
        <div className="w-14 h-14 rounded-2xl bg-[var(--color-accent)]/15 flex items-center justify-center mx-auto mb-4">
          <ShieldCheck className="w-7 h-7 text-[var(--color-accent)]" />
        </div>
        <h2 className="text-lg font-semibold text-[var(--color-text)] mb-2">
          ¿Proteger MalDolor con biometría?
        </h2>
        <p className="text-sm text-[var(--color-text-muted)] mb-6">
          Añade un bloqueo con Face ID, Touch ID o huella al abrir la app. Puedes
          cambiarlo cuando quieras desde tu perfil.
        </p>
        <button
          onClick={enable}
          className="w-full py-3.5 px-4 rounded-2xl bg-[var(--color-accent)] text-white font-medium mb-3"
        >
          Activar
        </button>
        <button
          onClick={skip}
          className="w-full py-3 px-4 rounded-2xl text-[var(--color-text-muted)] font-medium"
        >
          Ahora no
        </button>
      </div>
    </div>
  );
};
